var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorneMailIkon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 200 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M195.54 43.4v110.88H4.46V43.4zm0-3H4.46a3 3 0 0 0-3 3v110.88a3 3 0 0 0 3 3h191.08a3 3 0 0 0 3-3V43.4a3 3 0 0 0-3-3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2a2a2a",
  d: "M99.89 99.9a4.4 4.4 0 0 1-2.19-.59l-94.37-55 1.51-2.59 94.38 55a1.29 1.29 0 0 0 1.34 0l94.6-55 1.51 2.59-94.6 55a4.35 4.35 0 0 1-2.18.59"
})));
export default SvgNorneMailIkon;